var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:_vm.props.theme.input,attrs:{"name":_vm.props.getColumnName(_vm.props.column),"type":"text","autocomplete":"off"},on:{"keyup":function (e) { return _vm.search(e, _vm.props); }}})}
var staticRenderFns = []

export { render, staticRenderFns }